import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HasPermDirective } from './directives/has-perm.directive';
import { PermFormDirective } from './directives/perm-form.directive';
import { PermSelectDirective } from './directives/perm-select.directive';
import { PermCheckboxDirective } from './directives/perm-checkbox.directive';

import { PermChipDirective } from './directives/perm-chip.directive';
import { PermDatePickerDirective } from './directives/perm-date-picker.directive';
import { PermRadioDirective } from './directives/perm-radio.directive';
import { PermSwitchDirective } from './directives/perm-switch.directive';

/**
 * Лёгкий модуль ТОЛЬКО с директивой `*hasPerm` — без регистрации стора/эффектов.
 * Импортируется в любые feature-модули, где нужна `*hasPerm` в шаблонах.
 * (Стор/эффекты слайса access регистрируются один раз — в AccessModule из AppModule.)
 */
@NgModule({
  declarations: [
    HasPermDirective,
    PermFormDirective,
    PermSelectDirective,
    PermCheckboxDirective,
    PermChipDirective,
    PermDatePickerDirective,
    PermRadioDirective,
    PermSwitchDirective,
  ],
  imports: [CommonModule],
  exports: [
    HasPermDirective,
    PermFormDirective,
    PermSelectDirective,
    PermCheckboxDirective,
    PermChipDirective,
    PermDatePickerDirective,
    PermRadioDirective,
    PermSwitchDirective,
  ],
})
export class AccessUiModule {}

// Added PermCheckboxDirective to the module
